import React from "react";
import { compose } from "recompose";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import prop from "ramda/es/prop";
import map from "ramda/es/map";
import { browserHistory } from "react-router";

import {
  promised,
  withLog,
  showAllServerErrorsAsNotifications,
  appendToFormData,
  uniq
} from "../../../../helpers/utility";

import ServiceStudentsSelector from "./ServiceStudentsSelector";
import * as actionTypes from "../../../../actions/actions";
import Loading from "../../Loading/Loading";
import withLoading from "../../withLoadingHOC/withLoadingHOC";
import ServiceStudentsSelectorServiceOverview from "./ServiceStudentsSelectorServiceOverview";

import "./service-students-selector.scss";

function noop() {
  /* noop */
}

class ServiceStudentsSelectorContainer extends React.Component {
  state = { order: null, selectedStudentsIds: [] };

  componentDidMount = () => {
    this.fetchOrderData(this.props.params.orderId);
  };

  fetchOrderData = orderId => {
    if (!orderId) return;

    promised(this.props.fetchOrder, orderId)
      .then(this.onFetchOrderSuccess)
      .catch(showAllServerErrorsAsNotifications);
  };

  onFetchOrderSuccess = order => {
    this.setState({ order: order }, this.props.loading.onLoadingEnd);
  };

  onAddStudent = selectedStudentsIds => {
    // if user clicks on selectAll, an array with all students will be passed,
    // so this Array should be merged with existing one. but it needs to be
    // filtered for unique values (no duplicate students)
    if (Array.isArray(selectedStudentsIds)) {
      const newSelection = uniq([
        ...this.state.selectedStudentsIds,
        ...selectedStudentsIds
      ]);

      this.setState({
        selectedStudentsIds: newSelection
      });

      return;
    }

    // HANDLE SINGLE STUDENT SELECTION

    // make a copy of previously selected students, to avoid mutation of state
    const currentSelection = [...this.state.selectedStudentsIds];

    // find the individually selected student
    const index = currentSelection.indexOf(selectedStudentsIds);

    // toggle the selection
    if (index !== -1) {
      currentSelection.splice(index, 1);
    } else {
      currentSelection.push(selectedStudentsIds);
    }

    this.setState({
      selectedStudentsIds: currentSelection
    });
  };

  onSelectEnd = (selectedStudentsList, ignore_errors = false) => {
    if (selectedStudentsList.length === 0) {
      NotificationManager.error("حداقل یک دانش آموز باید انتخاب شود");
      return;
    }

    promised(
      this.props.updateOrder,
      this.props.params.orderId,
      appendToFormData({
        owners: map(prop("id"))(selectedStudentsList),
        ignore_errors: ignore_errors
      })
    )
      .then(this.onSelectedStudentsSubmitSuccess)
      .catch(showAllServerErrorsAsNotifications);
  };

  onSelectedStudentsSubmitSuccess = order => {
    NotificationManager.success(
      "دانش آموزان شرکت کننده با موفقیت انتخاب شدند."
    );
    browserHistory.push(`/dashboard/orders/${order.id}/payment-options`);
  };

  render() {
    if (this.props.loading.isLoading) return <Loading />;

    return (
      <section className="service-students-selector-container">
        <ServiceStudentsSelectorServiceOverview order={this.state.order} />

        <ServiceStudentsSelector
          onCellClick={this.onAddStudent}
          onStudentSelection={noop}
          onAddStudentsClick={this.onSelectEnd}
          service={this.state.order.service}
          selected={this.state.selectedStudentsIds}
        />
      </section>
    );
  }
}

const actions = {
  fetchOrder: (orderId, { resolve, reject }) => ({
    type: actionTypes.FETCH_SINGLE_ORDER_REQUEST,
    orderId,
    resolve,
    reject
  }),
  updateOrder: (orderId, formData, { resolve, reject }) => ({
    type: actionTypes.UPDATE_ORDER_REQUEST,
    orderId,
    formData,
    resolve,
    reject
  })
};

const HOC = compose(
  withLoading({ initialLoading: true }),
  connect(
    null,
    actions
  )
);

export default HOC(ServiceStudentsSelectorContainer);



// WEBPACK FOOTER //
// ./src/components/common/Services/ServiceStudentsSelector/ServiceStudentsSelectorContainer.js